import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "buttonText"]

  toggle() {
    if (this.formTarget.classList.contains("hidden")) {
      this.showForm()
    } else {
      this.hideForm()
    }
  }

  showForm() {
    this.formTarget.classList.remove("hidden")
    this.buttonTextTarget.textContent = "Cancel Edit"
    
    // Scroll to the form
    this.formTarget.scrollIntoView({ behavior: "smooth" })
  }

  hideForm() {
    this.formTarget.classList.add("hidden") 
    this.buttonTextTarget.textContent = "Edit Profile"
    
    // Scroll back to the top of the hero section
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  cancel() {
    this.hideForm()
  }
}